import React, { Component, Fragment } from 'react';
import { withMixpanel } from '../context/mixPanelContext';
import { isValid, parseISO, getDay } from 'date-fns';

import {
  object,
  string,
  boolean,
} from 'yup';

import {
  Container,
  Grid,
} from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';

import MaintenanceForm from '../layouts/MaintenanceForm';
import FormContainer from '../components/FormContainer';
import Faqs from '../components/Faqs';
import { fetchQuote, createLead } from '../utils/fetch';
import Hero from '../components/Maintenance/Hero';
import Background from '../components/Maintenance/Background';
import Header from '../components/Maintenance/Header';
import { commonStyles } from '../styles';
import { paramFromQueryString } from '../utils';

const isCoschedulingEnabled = document.documentElement.dataset.isCoschedulingEnabled === 'true';
const styles = theme => commonStyles(theme);
const nonformattedPhoneNumber = /^\d{10}$/;
const formattedPhoneNumber = /^\(\d{3}\)\s\d{3}-\d{4}$/;

const ContactSchema = object({
  service: object({
    product_sku: string()
      .required('Required'),
    date: string()
      .test('is-date-valid', 'Date is not valid', (value) => {
        const parsedDate = parseISO(value);
        return isValid(parsedDate) && getDay(parsedDate) !== 0
      })
      .required('Required'),
    time: string()
      .required('Required')
  }),
  user: object({
    first_name: string()
      .required('Required'),
    last_name: string()
      .required('Required'),
    email: string()
      .email('Email is not valid')
      .required('Required'),
    phone: string()
      .test('is-phone-valid', 'Phone number is not valid', value => {
        return formattedPhoneNumber.test(value) || nonformattedPhoneNumber.test(value);
      })
      .required('Required'),
  }),
  address: object({
    zipcode: string()
      .matches(/^(\d{5}|\w{3}( \w{3})?)$/, 'Zip Code is not valid')
      .required('Required')
  }),
  terms: boolean()
    .oneOf([true], 'Please agree to the terms and conditions'),
});

class Maintenance extends Component {
  handleSubmitTrack = (values, quote) => {
    const { mixpanel } = this.props;
    const { user, service } = values;
    const { zipcode, email } = user;
    const { product_sku, third_party_allowed } = service;
    const { starts_at } = quote;
    mixpanel.tracker('zip_submitted', {
      zip_code: zipcode,
      starts_at,
      third_party_allowed,
      email,
      product_sku,
    });
  }

  handleSubmit = async values => {
    const issueId = paramFromQueryString(this.props.location.search, 'issue_id');
    const {
      startLoading,
      stopLoading,
      updateFormInput,
      updateQuote,
      showError,
      hideError,
      service,
      user,
      address,
    } = this.props;

    startLoading();
    hideError();

    const stateData = {
      service: {
        ...service,
        ...values.service
      },
      user: {
        ...user,
        ...values.user
      },
      address: {
        ...address,
        ...values.address,
      },
      terms: values.terms,
      issue_id: issueId
    }

    try {
      const res = await fetchQuote(stateData);
      const { quote, address, serviceName } = res.data;
      const updatedAddress = {...stateData.address, ...address};
      updateFormInput({...stateData, address: updatedAddress, onBehalfOfPartnerMachineName: "nest_maintenance"});
      updateQuote(quote);
      await this.handleEmailLead(serviceName, values)
      this.nextPage();
      this.handleSubmitTrack(stateData, quote);
    } catch (error) {
      showError(error);
    } finally {
      stopLoading();

    }
  }

  handleEmailLead = (serviceName, values) => {
    return createLead({
      email_address: values.user.email,
      zip: values.address.zipcode,
      phone_number: values.user.phone,
      service_machine_name: serviceName,
      first_name: values.user.first_name,
      last_name: values.user.last_name,
      home_advisor_opt_in: true,
    })
  }

  nextPage() {
    const { search } = this.props.location;
    const { partnerOrderId } = this.props.match.params
    this.props.history.push(`/checkout${partnerOrderId ? `/${partnerOrderId}` : ''}${search}`);
  }

  componentDidMount() {
    const { mixpanel } = this.props;
    mixpanel.tracker('zip_shown');
  }

  render() {
    const { partnerOrderId } = this.props.match.params;

    const {
      service,
      user,
      address,
      isLoading,
      errorMessage,
      classes,
      systemType,
    } = this.props;

    const initialValues = {
      service: {
        ...service,
        time: '',
      },
      user,
      address: {
        zipcode: address.zipcode,
      },
      terms: !isCoschedulingEnabled,
    };

    return (
      <Fragment>
        <Background>
          <Container className={classes.container}>
            <Grid container>
              <Hero partnerOrderId={partnerOrderId} />
              <Grid item xs={12} md={6} lg={6} xl={5}>
                <FormContainer
                  className={classes.maintenanceForm}
                  initialValues={initialValues}
                  validationSchema={ContactSchema}
                  handleSubmit={this.handleSubmit}
                >
                  <MaintenanceForm
                    isLoading={isLoading}
                    errorMessage={errorMessage}
                    classes={classes}
                    systemType={systemType}
                  />
                </FormContainer>
              </Grid>
            </Grid>
          </Container>
        </Background>
        <Header />
        <Faqs customClass={classes.wrapperFaqHome} />
      </Fragment>
    );
  }
}

export default withStyles(styles)(withMixpanel(Maintenance));
